// Errors raised by the demo data layer. The API layer turns them into
// axios-shaped rejections (core demoError) so pages show the backend's `detail`.

export class DemoHttpError extends Error {
  readonly status: number;
  readonly detail: string;

  constructor(status: number, detail: string) {
    super(detail);
    this.name = 'DemoHttpError';
    this.status = status;
    this.detail = detail;
  }
}

export function fail(status: number, detail: string): never {
  throw new DemoHttpError(status, detail);
}
